export default "__VITE_PUBLIC_ASSET__30ff0a69__"